import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Merchant } from '../../../models/merchant/merchant';
import { Router } from '@angular/router';
import { TableView } from '../../ui/filterable-table/tableView';
import { UserTableViewComponent } from '../../user/user-table-view/user-table-view.component';
import { StorageService } from '../../../core/storage/storageService';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { MerchantUsersComponent } from '../merchant-users/merchant-users.component';
import { UserService } from '../../../models/users/userService';
import { CacheService } from '../../../core/storage/cacheService';
import { BaseComponent } from '../../baseComponent';
import { SolutionService } from '../../../models/solution/solutionService';
import { SolutionDetails } from '../../../models/solution/solutionDetails';
import { MerchantService } from '../../../models/merchant/merchantService';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-details',
  templateUrl: './merchant-details.component.html',
  standalone: false,
})
export class MerchantDetailsComponent extends BaseComponent {
  @Input() merchant: Merchant | undefined;

  @ViewChild('merchantUsersComponent')
  merchantUsersComponent: MerchantUsersComponent;

  allowEditing: boolean = false;
  allowViewing: boolean = false;
  scrollToYoffset: number = -73;

  accountHolderOptions: ListItem[] = CacheService.bankHolderTypesList;
  accountTypeOptions: ListItem[] = CacheService.bankAccountTypesList;

  userTableView: any;
  userTableOptions: any = {
    selectAction: 'select',
    filterable: false,
    paginated: false,
  };

  accountStatusOptions: ListItem[] = CacheService.accountStatusList;

  solution: SolutionDetails | undefined;

  allowEditBilling: boolean = false;
  allowEditUsers: boolean = false;

  allowViewBusinessInfo: boolean = false;
  allowEditBusinessInfo: boolean = false;
  allowViewContact: boolean = false;
  allowEditContact: boolean = false;
  allowViewSettings: boolean = false;
  allowEditSettings: boolean = false;
  allowImpersonateUsers: boolean = false;
  allowViewProcessors: boolean = false;
  allowEditProcessors: boolean = true; // TODO: Update this

  hideForBeta: boolean = true;

  constructor(
    userService: UserService,
    private merchantService: MerchantService,
    private solutionService: SolutionService,
    public storage: StorageService,
    public router: Router,
    private access: AccessManager,
    private uiErrorHandler: UIErrorHandler,
    private cdr: ChangeDetectorRef
  ) {
    super();

    // required by Typescript
    this.merchantUsersComponent = new MerchantUsersComponent(
      storage,
      userService,
      uiErrorHandler,
      access,
    );

    this.access
      .getUserAccess([
        AccessManager.AUTH_UPDATE_MERCHANT_ACCOUNT,
        AccessManager.AUTH_SELECT_MERCHANT_ACCOUNT,
        AccessManager.AUTH_SELECT_MERCHANT_CONTACTS,
        AccessManager.AUTH_UPDATE_MERCHANT_CONTACTS,
        AccessManager.AUTH_SELECT_MERCHANT_SETTINGS,
        AccessManager.AUTH_UPDATE_MERCHANT_SETTINGS,
        AccessManager.AUTH_UPDATE_MERCHANT_BILLING,
        AccessManager.AUTH_SELECT_MERCHANT_BILLING,
        AccessManager.AUTH_UPDATE_MERCHANT_BILLING,
        AccessManager.AUTH_UPDATE_MERCHANT_SETTINGS,

        AccessManager.AUTH_SELECT_MERCHANT_PROCESSORS,
        AccessManager.AUTH_UPDATE_MERCHANT_PROCESSORS,
        AccessManager.AUTH_UPDATE_MERCHANT_USERS,
        AccessManager.AUTH_UPDATE_MERCHANT_INFO,
        AccessManager.AUTH_SELECT_MERCHANT_INFO,
      ])
      .then((accessRecord) => {
        this.allowEditing = accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_ACCOUNT];
        this.allowViewing = accessRecord[AccessManager.AUTH_SELECT_MERCHANT_ACCOUNT];
        
        this.allowViewContact = this.allowViewing || accessRecord[AccessManager.AUTH_SELECT_MERCHANT_CONTACTS];
        this.allowEditContact = this.allowEditing || accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_INFO];

        this.allowEditBilling =
          accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_BILLING];

        this.allowViewBusinessInfo = this.allowViewing ||
          accessRecord[AccessManager.AUTH_SELECT_MERCHANT_INFO];
        this.allowEditBusinessInfo = this.allowEditing ||
          accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_INFO];

        this.allowImpersonateUsers =
          accessRecord[AccessManager.AUTH_IMPERSONATE_USER];

        this.allowViewProcessors = this.allowViewing ||
          accessRecord[AccessManager.AUTH_SELECT_MERCHANT_PROCESSORS];
        this.allowEditProcessors = this.allowEditing ||
          accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_PROCESSORS];
        //this.merchantUsersComponent.updatePermissions(
        //    accessRecord[AccessManager.AUTH_UPDATE_MERCHANT_USERS],
        //    accessRecord[AccessManager.AUTH_IMPERSONATE_USER]
        //);
        this.cdr.detectChanges();
      })

      /*
    allowViewBusinessInfo: boolean = false;
    allowEditBusinessInfo: boolean = false;
    allowViewContact: boolean = false;
    allowEditContact: boolean = false;
    allowViewSettings: boolean = false;
    allowEditSettings: boolean = false;
    allowImpersonateUsers: boolean = false;
    allowEditProcessors: boolean = true; // TODO: Update this
*/
      .catch((e) => {
        this.uiErrorHandler.handleError(e);
      });
    // TODO (jacob): Add error service
    //               throw if merchant is null
    //this.contactForm = ViewChild("contactForm");

    //TODO: merchant's current account status is not loading

    // This should only be set by the @Input()
    //let merchant = storage.getSelectedLocation();

    //this.solution = new SolutionDetails({});

    // if (this.merchant != undefined) {

    //     this.solutionService.getById("84b3b787-6253-4637-b64c-64876c33a7e0")
    //     .then(s => {
    //         this.solution = s;
    //     })

    //     this.userTableOptions.merchantId = merchant.id;
    //     this.userTableView = new TableView(UserTableViewComponent);
    // }
  }

  ngOnInit() {
    this.solution = new SolutionDetails({});

    if (!this.merchant) {
      throw 'merchant-details: merchant is undefined';
    }

    // this.solutionService.getById("84b3b787-6253-4637-b64c-64876c33a7e0")
    // .then(s => {
    //     this.solution = s;
    // })

    console.log('merchant', this.merchant);
    this.userTableOptions.merchantId = this.merchant.id;
    this.userTableView = new TableView(UserTableViewComponent);
  }

  ngAfterViewInit() {
    // feels a little hacky -- this is designed to give a tick (which is apparently enough time) for the tabs to be ready
    setTimeout(() => this.selectBookmark('merchantInfoContainer'));
  }

  handleCreateNewTransaction(merchantId: string) {
    this.router.navigate(['/merchants/terminal']);
  }

  selectBookmark(selector: string) {
    // let tabs = document.getElementsByClassName("content selected");
    // for (var i=0; i<tabs.length; i++) {
    //     tabs[i].classList.remove("selected");
    // }

    // let tabContents = document.getElementsByClassName("tabContent selected");
    // for (var i=0; i<tabContents.length; i++) {
    //     tabContents[i].classList.remove("selected");
    // }
    document
      .querySelectorAll('.content.selected')
      .forEach((el) => el.classList.remove('selected'));

    document
      .querySelectorAll('.tabContent.selected')
      .forEach((el) => el.classList.remove('selected'));

    const selectedTab = document.getElementById('tab_' + selector);
    selectedTab?.children[0].classList.add('selected');

    const selectedTabContent = document.getElementById(selector);
    selectedTabContent?.classList.add('selected');
  }

  handleSaved(saved: boolean) {
    if (saved) {
      this._reloadMerchant();
    }
  }

  handleContactUpdated(updated: boolean) {
    if (updated) {
      this._reloadMerchant();
    }
  }

  _reloadMerchant() {
    this.merchantService
      .getMerchantById(this.merchant?.id || '')
      .then((merchant) => {
        this.merchant = merchant;
        this.storage.setSelectedLocation(merchant);
      });
  }
}
